import type { EditorDefaultFieldsProps } from "./schema-builder-field-editor-default.type";

import { useTranslation } from "react-i18next";

import { FieldCheckbox } from "@/ui/field-checkbox";
import { FieldText } from "@/ui/field-text";

export const EditorDefaultFields = ({ disabled }: EditorDefaultFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <FieldText
        name="label"
        label={t(`schema:property.label`)}
        disabled={disabled}
        required
      />
      <FieldText
        name="model"
        label={t(`schema:property.model`)}
        disabled={disabled}
        required
      />
      <FieldText
        name="placeholder"
        label={t(`schema:property.placeholder`)}
        disabled={disabled}
      />
      <FieldText
        name="hint"
        label={t(`schema:property.hint`)}
        disabled={disabled}
      />
      <FieldCheckbox name="readOnly" hidden />
    </>
  );
};
